import { useState } from "react";
import { Heart, Menu, Search, ShoppingBag, User, X } from "lucide-react";
import { ASSETS } from "@/data/magicalContent";
import { scrollToId } from "@/utils/scroll";

const LINKS = [
  ["Home", "home"],
  ["Watch Episodes", "/season-1"],
  ["Songs", "songs"],
  ["Meet the Characters", "characters"],
  ["Shop", "shop"],
  ["New Arrivals", "new-arrivals"],
  ["About", "about"],
  ["Contact", "newsletter"],
];

const linkHref = (id) => (id.startsWith("/") ? id : `#${id}`);

const STORE_LINK_IDS = new Set(["shop", "new-arrivals"]);

export function Header({ user, cartCount, wishlistCount, onCartOpen, onWishlistOpen, onAccountOpen, showStore = true }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const links = showStore ? LINKS : LINKS.filter(([, id]) => !STORE_LINK_IDS.has(id));

  const submitSearch = (event) => {
    event.preventDefault();
    setSearchOpen(false);
    scrollToId("episodes");
  };

  return (
    <header className="ns-header" data-testid="site-header">
      <nav className="ns-nav" data-testid="main-navigation" aria-label="Main navigation">
        <button className="ns-menu-button" data-testid="mobile-menu-button" onClick={() => setMenuOpen(true)} aria-label="Open navigation"><Menu size={21} /></button>
        <a className="ns-brand" href="#home" data-testid="brand-logo" aria-label="Niyati and Shivu home"><img src={ASSETS.logo} alt="Niyati & Shivu official logo" /><span><strong>Niyati &amp; Shivu</strong><small>Magical World</small></span></a>
        <div className="ns-nav-links" data-testid="navigation-links">{links.map(([label, id]) => <a key={label} href={linkHref(id)} data-testid={`nav-${id.replace("/", "")}-link`}>{label}</a>)}</div>
        <div className="ns-nav-actions">
          {showStore && <select className="ns-currency" data-testid="country-currency-selector" defaultValue="IN-INR" aria-label="Country and currency"><option value="IN-INR">IN · ₹</option><option value="US-USD">US · $</option><option value="GB-GBP">UK · £</option><option value="EU-EUR">EU · €</option><option value="AE-AED">AE · AED</option></select>}
          <button className="ns-icon-button" data-testid="search-button" onClick={() => setSearchOpen(!searchOpen)} aria-label="Search"><Search size={18} /></button>
          {showStore && <button className="ns-icon-button" data-testid="wishlist-button" onClick={onWishlistOpen} aria-label="Wishlist"><Heart size={18} /><sup>{wishlistCount || ""}</sup></button>}
          <button className="ns-icon-button ns-account" data-testid="account-button" onClick={onAccountOpen} aria-label="Account"><User size={18} />{user?.name && <small>{user.name.split(" ")[0]}</small>}</button>
          {showStore && <button className="ns-cart-button" data-testid="cart-open-button" onClick={onCartOpen} aria-label="Open adventure bag"><ShoppingBag size={18} /><span>Bag</span><b>{cartCount}</b></button>}
        </div>
      </nav>
      {searchOpen && <form className="ns-search-panel" data-testid="search-panel" onSubmit={submitSearch}><Search size={17} /><input data-testid="search-input" autoFocus placeholder={showStore ? "Search episodes, songs or products…" : "Search episodes or songs…"} /><button type="submit" data-testid="search-submit-button">Search</button></form>}
      {menuOpen && <div className="ns-mobile-menu" data-testid="mobile-menu-panel"><button data-testid="mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="Close navigation"><X /></button>{links.map(([label, id]) => <a key={label} href={linkHref(id)} onClick={() => setMenuOpen(false)} data-testid={`mobile-nav-${id.replace("/", "")}-link`}>{label}</a>)}</div>}
    </header>
  );
}
